import { Menu, Shield } from 'lucide-react';

interface AdminMobileHeaderProps {
  onMenuClick: () => void;
}

export function AdminMobileHeader({ onMenuClick }: AdminMobileHeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-slate-900 border-b border-slate-800 z-40 lg:hidden">
      <div className="flex items-center justify-between h-full px-4">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 bg-gradient-to-br from-red-500 to-orange-500 rounded-xl flex items-center justify-center">
            <Shield className="w-4 h-4 text-white" />
          </div>
          <div>
            <span className="text-lg font-bold text-white">MAMAL</span>
            <span className="ml-2 text-xs font-medium text-orange-400 bg-orange-400/10 px-2 py-0.5 rounded-full">
              Admin
            </span>
          </div>
        </div>
        <button
          onClick={onMenuClick}
          className="p-2 hover:bg-slate-800 rounded-xl transition-colors"
        >
          <Menu className="w-6 h-6 text-slate-400" />
        </button>
      </div>
    </header>
  );
}
